module.exports = __webpack_public_path__ + "files/1b73112c110a3ae837f00c83aaa21bd6.png";